import styled from 'styled-components';

export const AccordionContent = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 1px;

  &:last-child {
    border-bottom: 1px solid #eceeef;
  }
`;

export const HeaderTitle = styled.div`
  background-color: #fff;
  color: #555;
  display: flex;
  align-items: center;
  transition: 0.6s ease;
  width: 100%;
  min-height: 80px;
  height: 100px;
  height: 80px;
  border-top: 1px solid #eceeef;
  cursor: pointer;

  > p {
    font-weight: 600;
    font-size: 16px;
    text-align: left;
    padding: 1.7rem 0rem;
    width: 100%;
    transition: 0.6s ease;
  }

  &.active {
    color: #166649;
    background-color: #f3f3f3;
    transition: 0.6s ease-in-out;
  }

  &.active p {
    padding-left: 1rem;
  }

  svg {
    &.accordion__icon {
      margin-left: auto;
      transition: transform 0.6s ease;

      &.rotate {
        transform: rotate(-180deg);
      }
    }
  }
`;

export const Collapse = styled.div`
  background-color: white;
  overflow: auto;
  transition: 0.6s ease;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const BodyContent = styled.div`
  font-weight: 400;
  font-size: 14px;
  padding: 18px;
  margin-top: 1px;
  transition: 0.6s ease-in-out;
  transform: translateY(-1rem);
  opacity: 0;

  &.active {
    background-color: #f3f3f3;
    transition: 0.6s ease-in-out;
    transform: translateY(0px);
    opacity: 1;
  }
`;
